import { useEffect, useState } from "react";
import axios from "axios";

// How this instance looks and whom people contact - set under Platform
// settings → Branding, read once from /neoPublic/branding (no sign-in).
// Until it arrives, and if it can't be read, today's Business Flows values apply.
export const DEFAULT_BRANDING = {
  productName: "Business Flows",
  companyName: "bpExperts GmbH",
  companyUrl: "https://www.bpexperts.de",
  logoUrl: "/Business Flows_Logo_RGB.png",
  primaryColour: "#1a1a2e",
  supportEmail: "sales@bpexperts.de",
  imprintUrl: "https://www.bpexperts.de/impressum",
  privacyUrl: "https://www.bpexperts.de/privacy-statement",
  termsUrl: "https://www.bpexperts.de/gtc",
  // Also receives a copy of contact, upgrade and registration emails - today's
  // hard-coded bcc, now an optional setting (Platform settings → Branding).
  contactBcc: "russell.gomersall@bpexperts.de",
  instanceMode: "shared",
};

export const mergeBranding = (fromServer) => {
  const merged = { ...DEFAULT_BRANDING };
  Object.entries(fromServer || {}).forEach(([key, value]) => {
    if (!(key in DEFAULT_BRANDING) || typeof value !== "string") return;
    // contactBcc alone may be explicitly empty - that's an admin choosing "no
    // copy", not a missing field, so it must not fall back to the default.
    // Every other field still falls back to the default when blank.
    if (key === "contactBcc") merged[key] = value.trim();
    else if (value.trim()) merged[key] = value.trim();
  });
  return merged;
};

export const mailto = (address, subject, bcc) => {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (bcc) params.push(`bcc=${encodeURIComponent(bcc)}`);
  return `mailto:${address}${params.length ? `?${params.join("&")}` : ""}`;
};

let current = DEFAULT_BRANDING;
let pending = null;
const listeners = new Set();

export const loadBranding = () => {
  if (!pending) {
    pending = axios
      .get("/neoPublic/branding")
      .then((res) => {
        current = mergeBranding(res.data?.content);
        if (typeof document !== "undefined") document.title = current.productName;
        listeners.forEach((listener) => listener(current));
        return current;
      })
      .catch(() => current);
  }
  return pending;
};

export const brandingNow = () => current;

export default function useBranding() {
  const [branding, setBranding] = useState(current);
  useEffect(() => {
    listeners.add(setBranding);
    setBranding(current);
    loadBranding();
    return () => listeners.delete(setBranding);
  }, []);
  return branding;
}
